
import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { AutoTranslateService } from 'app/services/auto-translate.service';
import { LanguageService } from 'app/services/language.service';

@Injectable()
export class CustomMatPaginatorIntl extends MatPaginatorIntl {
  constructor(
    private autoTranslateService: AutoTranslateService,
    private languageService: LanguageService,
  ) {
    super();

    this.getAndInitTranslations();
    this.languageService.getLanguage$().subscribe(() => {
      this.getAndInitTranslations();
    });
  }

  async getAndInitTranslations() {
    this.itemsPerPageLabel = await this.autoTranslateService.translateSync('Itens por página');
    this.nextPageLabel = await this.autoTranslateService.translateSync('Próxima');
    this.previousPageLabel = await this.autoTranslateService.translateSync('Anterior');
    this.lastPageLabel = await this.autoTranslateService.translateSync('Última');
    this.firstPageLabel = await this.autoTranslateService.translateSync('Primeira');
    this.changes.next();
  }

 getRangeLabel = (page: number, pageSize: number, length: number) =>  {
    if (length === 0 || pageSize === 0) {
      return `0 de ${length}`;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
    return `${startIndex + 1} - ${endIndex} de ${length}`;
  }
}
